import template from './birthday_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportBirthdayViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_birthdays = ko.observableArray();
		this.loader = ko.observable(false);
	}

	show_birthdays_setup_help()
	{
		Grape.dialog.open('UpcomingBirthdaysHelp', {});
	}
}

class ReportBirthdayPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportBirthdayViewModel(this);
		window.current_page_title(tr('Upcoming Birthdays'));
	}

	async updateData()
	{
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/general/birthday_list');

		if (res.birthdays != null)
		{
			for (let i = 0; i < res.birthdays.length; i++)
			{
				res.birthdays[i].fullName = res.birthdays[i].firstname + ' ' + res.birthdays[i].surname;
			}

			this.viewModel.employee_birthdays(res.birthdays);
		}
		this.viewModel.loader(false);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('UpcomingBirthdaysReport'))
			return;

		document.title = tr('Upcoming Birthdays');
	}
}

export default {
	route: '[/]general/birthdays_report',
	page_class: ReportBirthdayPage,
	template: template,
	template_filename: 'translation/birthday_report'
};
